import { render } from "./ViewGroupList.vue?vue&type=template&id=7cd9a53e&scoped=true"
import script from "./ViewGroupList.vue?vue&type=script&lang=js"
export * from "./ViewGroupList.vue?vue&type=script&lang=js"

import "./ViewGroupList.vue?vue&type=style&index=0&id=7cd9a53e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd9a53e"]])

export default __exports__